/* eslint-disable */
/* global PowerPoint console */

export async function getSlideMasterData(slideId) {
  const result = { xmlParts: [], shapes: [], layouts: [] };
  try {
    await PowerPoint.run(async (context) => {
      const slideMaster = context.presentation.slides.getItem(slideId).slideMaster;
      slideMaster.customXmlParts.load({ id: true });
      slideMaster.shapes.load({ id: true });
      slideMaster.layouts.load({ id: true });
      await context.sync();

      for (let i = 0; i < slideMaster.shapes.items.length; i++) {
        const shape = slideMaster.shapes.items[i];
        shape.load({ id: true, name: true, type: true });
        await context.sync();
        try {
          if (shape.type === "Group") {
            shape.group.shapes.load({ id: true, name: true });
            await context.sync();
            for (let j = 0; j < shape.group.shapes.items.length; j++) {
              const innerShape = shape.group.shapes.items[j];
              try {
                innerShape.load({
                  lineFormat: { color: true, weight: true, style: true },
                  fill: { foregroundColor: true, type: true },
                  textFrame: {
                    textRange: {
                      font: { name: true, color: true, bold: true, italic: true, size: true },
                    },
                  },
                });
                await context.sync();
                result.shapes.push({
                  id: innerShape.id,
                  name: innerShape.name,
                  lineFormatColor: innerShape.lineFormat.color,
                  lineFormatWeight: innerShape.lineFormat.weight,
                  lineFormatStyle: innerShape.lineFormat.style,
                  foregroundColorFill: innerShape.fill.foregroundColor,
                  fillType: innerShape.fill.type,
                  fontName: innerShape.textFrame.textRange.font.name,
                  fontColor: innerShape.textFrame.textRange.font.color,
                  fontBold: innerShape.textFrame.textRange.font.bold,
                  fontItalic: innerShape.textFrame.textRange.font.italic,
                  fontSize: innerShape.textFrame.textRange.font.size,
                });
              } catch (error) {
                console.warn("Failed to get inner shape styling", {
                  id: shape.id,
                  name: shape.name,
                  error,
                });
              }
            }
          } else {
            shape.load({
              lineFormat: { color: true, weight: true, style: true },
              fill: { foregroundColor: true, type: true },
              textFrame: {
                textRange: {
                  font: { name: true, color: true, bold: true, italic: true, size: true },
                },
              },
            });
            await context.sync();
            result.shapes.push({
              id: shape.id,
              name: shape.name,
              lineFormatColor: shape.lineFormat.color,
              lineFormatWeight: shape.lineFormat.weight,
              lineFormatStyle: shape.lineFormat.style,
              foregroundColorFill: shape.fill.foregroundColor,
              fillType: shape.fill.type,
              fontName: shape.textFrame.textRange.font.name,
              fontColor: shape.textFrame.textRange.font.color,
              fontBold: shape.textFrame.textRange.font.bold,
              fontItalic: shape.textFrame.textRange.font.italic,
              fontSize: shape.textFrame.textRange.font.size,
            });
          }
        } catch (error) {
          console.warn("Failed to get shape styling", { id: shape.id, name: shape.name });
        }
      }

      for (let i = 0; i < slideMaster.layouts.items.length; i++) {
        const layout = slideMaster.layouts.items[i];
        layout.load({ id: true, name: true, type: true });
        await context.sync();
        result.layouts.push({ id: layout.id, name: layout.name, type: layout.type });
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }

  return result;
}

export async function getLayoutSlideData(slideId) {
  const result = { id: "", name: "", type: "", xmlParts: [], shapes: [] };
  try {
    await PowerPoint.run(async (context) => {
      const slide = slideId ? context.presentation.slides.getItem(slideId) : context.presentation.slides.getItemAt(0);
      const layout = slide.layout;
      layout.load({ id: true, name: true, type: true });
      layout.customXmlParts.load({ id: true });
      layout.shapes.load({ id: true });
      await context.sync();
      result.id = layout.id;
      result.name = layout.name;
      result.type = layout.type;

      for (let i = 0; i < layout.shapes.items.length; i++) {
        const shape = layout.shapes.items[i];
        shape.load({ id: true, name: true, type: true });
        await context.sync();
        try {
          if (shape.type === "Group") {
            shape.group.shapes.load({ id: true, name: true });
            await context.sync();
            for (let j = 0; j < shape.group.shapes.items.length; j++) {
              const innerShape = shape.group.shapes.items[j];
              try {
                innerShape.load({
                  lineFormat: { color: true, weight: true, style: true },
                  fill: { foregroundColor: true, type: true },
                  textFrame: {
                    textRange: {
                      font: { name: true, color: true, bold: true, italic: true, size: true },
                    },
                  },
                });
                await context.sync();
                result.shapes.push({
                  id: innerShape.id,
                  name: innerShape.name,
                  lineFormatColor: innerShape.lineFormat.color,
                  lineFormatWeight: innerShape.lineFormat.weight,
                  lineFormatStyle: innerShape.lineFormat.style,
                  foregroundColorFill: innerShape.fill.foregroundColor,
                  fillType: innerShape.fill.type,
                  fontName: innerShape.textFrame.textRange.font.name,
                  fontColor: innerShape.textFrame.textRange.font.color,
                  fontBold: innerShape.textFrame.textRange.font.bold,
                  fontItalic: innerShape.textFrame.textRange.font.italic,
                  fontSize: innerShape.textFrame.textRange.font.size,
                });
              } catch (error) {
                console.warn("Failed to get inner shape styling", {
                  id: shape.id,
                  name: shape.name,
                  error,
                });
              }
            }
          } else {
            shape.load({
              lineFormat: { color: true, weight: true, style: true },
              fill: { foregroundColor: true, type: true },
              textFrame: {
                textRange: {
                  font: { name: true, color: true, bold: true, italic: true, size: true },
                },
              },
            });
            await context.sync();
            result.shapes.push({
              id: shape.id,
              name: shape.name,
              lineFormatColor: shape.lineFormat.color,
              lineFormatWeight: shape.lineFormat.weight,
              lineFormatStyle: shape.lineFormat.style,
              foregroundColorFill: shape.fill.foregroundColor,
              fillType: shape.fill.type,
              fontName: shape.textFrame.textRange.font.name,
              fontColor: shape.textFrame.textRange.font.color,
              fontBold: shape.textFrame.textRange.font.bold,
              fontItalic: shape.textFrame.textRange.font.italic,
              fontSize: shape.textFrame.textRange.font.size,
            });
          }
        } catch (error) {
          console.warn("Failed to get shape styling", { id: shape.id, name: shape.name });
        }
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }

  return result;
}

export async function getSlideData(slideId) {
  const result = { id: "", name: "", type: "", xmlParts: [], shapes: [] };
  try {
    await PowerPoint.run(async (context) => {
      const slide = context.presentation.slides.getItem(slideId);
      slide.shapes.load({ id: true });
      await context.sync();
      result.id = slide.id;

      for (let i = 0; i < slide.shapes.items.length; i++) {
        const shape = slide.shapes.items[i];
        shape.load({ id: true, name: true, type: true });
        await context.sync();
        try {
          if (shape.type === "Group") {
            shape.group.shapes.load({ id: true, name: true });
            await context.sync();
            for (let j = 0; j < shape.group.shapes.items.length; j++) {
              const innerShape = shape.group.shapes.items[j];
              try {
                innerShape.load({
                  lineFormat: { color: true, weight: true, style: true },
                  fill: { foregroundColor: true, type: true },
                  textFrame: {
                    textRange: {
                      font: { name: true, color: true, bold: true, italic: true, size: true },
                    },
                  },
                });
                await context.sync();
                result.shapes.push({
                  id: innerShape.id,
                  name: innerShape.name,
                  lineFormatColor: innerShape.lineFormat.color,
                  lineFormatWeight: innerShape.lineFormat.weight,
                  lineFormatStyle: innerShape.lineFormat.style,
                  foregroundColorFill: innerShape.fill.foregroundColor,
                  fillType: innerShape.fill.type,
                  fontName: innerShape.textFrame.textRange.font.name,
                  fontColor: innerShape.textFrame.textRange.font.color,
                  fontBold: innerShape.textFrame.textRange.font.bold,
                  fontItalic: innerShape.textFrame.textRange.font.italic,
                  fontSize: innerShape.textFrame.textRange.font.size,
                });
              } catch (error) {
                console.warn("Failed to get inner shape styling", {
                  id: shape.id,
                  name: shape.name,
                  error,
                });
              }
            }
          } else {
            shape.load({
              lineFormat: { color: true, weight: true, style: true },
              fill: { foregroundColor: true, type: true },
              textFrame: {
                textRange: {
                  font: { name: true, color: true, bold: true, italic: true, size: true },
                },
              },
            });
            await context.sync();
            result.shapes.push({
              id: shape.id,
              name: shape.name,
              lineFormatColor: shape.lineFormat.color,
              lineFormatWeight: shape.lineFormat.weight,
              lineFormatStyle: shape.lineFormat.style,
              foregroundColorFill: shape.fill.foregroundColor,
              fillType: shape.fill.type,
              fontName: shape.textFrame.textRange.font.name,
              fontColor: shape.textFrame.textRange.font.color,
              fontBold: shape.textFrame.textRange.font.bold,
              fontItalic: shape.textFrame.textRange.font.italic,
              fontSize: shape.textFrame.textRange.font.size,
            });
          }
        } catch (error) {
          console.warn("Failed to get shape styling", { id: shape.id, name: shape.name });
        }
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }

  return result;
}

export async function getAllColors() {
  let titleColor = "";
  let bodyColor = "";
  let shapeFills = [];
  const result = [];
  try {
    await PowerPoint.run(async (context) => {
      context.presentation.slides.load({ id: true });
      context.presentation.slideMasters.load({ id: true });
      await context.sync();

      for (let i = 0; i < context.presentation.slides.items.length; i++) {
        const slide = context.presentation.slides.items[i];
        slide.shapes.load({ id: true, type: true, name: true });
        await context.sync();
        for (let j = 0; j < slide.shapes.items.length; j++) {
          const shape = slide.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, name: true, type: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    name: true,
                    lineFormat: { color: true },
                    fill: { foregroundColor: true },
                  });
                  await context.sync();
                  result.push(innerShape.lineFormat.color, innerShape.fill.foregroundColor);
                  if (innerShape.type === "GeometricShape") shapeFills.push(innerShape.fill.foregroundColor);

                  try {
                    innerShape.load({
                      textFrame: { hasText: true, textRange: { font: { color: true } } },
                    });
                    await context.sync();
                    result.push(innerShape.textFrame.hasText ? innerShape.textFrame.textRange.font.color : undefined);
                    if (titleColor === "" && innerShape.name.startsWith("Title")) {
                      titleColor = innerShape.textFrame.textRange.font.color;
                    }
                    if (
                      bodyColor === "" &&
                      (innerShape.name.startsWith("Content") || innerShape.name.startsWith("Text"))
                    ) {
                      bodyColor = innerShape.textFrame.textRange.font.color;
                    }
                  } catch (_) {}
                } catch (_) {}
              }
            } else {
              shape.load({
                lineFormat: { color: true },
                fill: { foregroundColor: true },
              });
              await context.sync();
              result.push(shape.lineFormat.color, shape.fill.foregroundColor);
              if (shape.type === "GeometricShape") shapeFills.push(shape.fill.foregroundColor);

              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { color: true } } },
                });
                await context.sync();
                result.push(shape.textFrame.hasText ? shape.textFrame.textRange.font.color : undefined);
                if (titleColor === "" && shape.name.startsWith("Title")) {
                  titleColor = shape.textFrame.textRange.font.color;
                }
                if (bodyColor === "" && (shape.name.startsWith("Content") || shape.name.startsWith("Text"))) {
                  bodyColor = shape.textFrame.textRange.font.color;
                }
              } catch (_) {}
            }
          } catch (_) {}
        }
      }

      for (let i = 0; i < context.presentation.slideMasters.items.length; i++) {
        const master = context.presentation.slideMasters.items[i];

        master.shapes.load({ id: true, type: true, name: true });
        master.layouts.load({ id: true });
        await context.sync();

        for (let j = 0; j < master.shapes.items.length; j++) {
          const shape = master.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, name: true, type: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    name: true,
                    lineFormat: { color: true },
                    fill: { foregroundColor: true },
                  });
                  await context.sync();
                  result.push(innerShape.lineFormat.color, innerShape.fill.foregroundColor);
                  if (innerShape.type === "GeometricShape") shapeFills.push(innerShape.fill.foregroundColor);

                  try {
                    innerShape.load({
                      textFrame: { hasText: true, textRange: { font: { color: true } } },
                    });
                    await context.sync();
                    result.push(innerShape.textFrame.hasText ? innerShape.textFrame.textRange.font.color : undefined);
                    if (titleColor === "" && innerShape.name.startsWith("Title")) {
                      titleColor = innerShape.textFrame.textRange.font.color;
                    }
                    if (
                      bodyColor === "" &&
                      (innerShape.name.startsWith("Content") || innerShape.name.startsWith("Text"))
                    ) {
                      bodyColor = innerShape.textFrame.textRange.font.color;
                    }
                  } catch (_) {}
                } catch (_) {}
              }
            } else {
              shape.load({
                lineFormat: { color: true },
                fill: { foregroundColor: true },
              });
              await context.sync();
              result.push(shape.lineFormat.color, shape.fill.foregroundColor);
              if (shape.type === "GeometricShape") shapeFills.push(shape.fill.foregroundColor);

              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { color: true } } },
                });
                await context.sync();
                result.push(shape.textFrame.hasText ? shape.textFrame.textRange.font.color : undefined);
                if (titleColor === "" && shape.name.startsWith("Title")) {
                  titleColor = shape.textFrame.textRange.font.color;
                }
                if (bodyColor === "" && (shape.name.startsWith("Content") || shape.name.startsWith("Text"))) {
                  bodyColor = shape.textFrame.textRange.font.color;
                }
              } catch (_) {}
            }
          } catch (error) {
            console.error("failed style", { shape, error });
          }
        }

        for (let j = 0; j < master.layouts.items.length; j++) {
          const layout = master.layouts.items[j];
          layout.shapes.load({ id: true, type: true, name: true });
          await context.sync();
          for (let k = 0; k < layout.shapes.items.length; k++) {
            const shape = layout.shapes.items[k];
            try {
              if (shape.type === "Group") {
                shape.group.shapes.load({ id: true, name: true, type: true });
                await context.sync();
                for (let j = 0; j < shape.group.shapes.items.length; j++) {
                  const innerShape = shape.group.shapes.items[j];
                  try {
                    innerShape.load({
                      name: true,
                      lineFormat: { color: true },
                      fill: { foregroundColor: true },
                    });
                    await context.sync();
                    result.push(innerShape.lineFormat.color, innerShape.fill.foregroundColor);
                    if (innerShape.type === "GeometricShape") shapeFills.push(innerShape.fill.foregroundColor);

                    try {
                      innerShape.load({
                        textFrame: { hasText: true, textRange: { font: { color: true } } },
                      });
                      await context.sync();
                      result.push(innerShape.textFrame.hasText ? innerShape.textFrame.textRange.font.color : undefined);
                      if (titleColor === "" && innerShape.name.startsWith("Title")) {
                        titleColor = innerShape.textFrame.textRange.font.color;
                      }
                      if (
                        bodyColor === "" &&
                        (innerShape.name.startsWith("Content") || innerShape.name.startsWith("Text"))
                      ) {
                        bodyColor = innerShape.textFrame.textRange.font.color;
                      }
                    } catch (_) {}
                  } catch (_) {}
                }
              } else {
                shape.load({
                  lineFormat: { color: true },
                  fill: { foregroundColor: true },
                });
                await context.sync();
                result.push(shape.lineFormat.color, shape.fill.foregroundColor);
                if (shape.type === "GeometricShape") shapeFills.push(shape.fill.foregroundColor);

                try {
                  shape.load({
                    textFrame: { hasText: true, textRange: { font: { color: true } } },
                  });
                  await context.sync();
                  result.push(shape.textFrame.hasText ? shape.textFrame.textRange.font.color : undefined);
                  if (titleColor === "" && shape.name.startsWith("Title")) {
                    titleColor = shape.textFrame.textRange.font.color;
                  }
                  if (bodyColor === "" && (shape.name.startsWith("Content") || shape.name.startsWith("Text"))) {
                    bodyColor = shape.textFrame.textRange.font.color;
                  }
                } catch (_) {}
              }
            } catch (error) {
              console.error("failed style", { shape, error });
            }
          }
        }
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }
  const uniqueColors = Object.groupBy(
    result.filter((f) => f && f !== ""),
    (i) => i.trim()
  );
  const uniqueColorsSorted = Object.keys(uniqueColors).sort((a, b) => uniqueColors[b].length - uniqueColors[a].length);
  const uniqueShapeColors = Object.groupBy(
    shapeFills.filter((f) => f && f !== ""),
    (i) => i.trim()
  );
  const uniqueShapeColorsSorted = Object.keys(uniqueShapeColors).sort(
    (a, b) => uniqueShapeColors[b].length - uniqueShapeColors[a].length
  );

  const formedResult = [
    { key: titleColor, count: 10000000 },
    { key: bodyColor, count: 10000000 },
    ...uniqueShapeColorsSorted.map((key) => ({
      key,
      count: uniqueShapeColors[key].length + (uniqueColors[key]?.length ?? 0),
    })),
    ...uniqueColorsSorted
      .filter((key) => uniqueShapeColors[key] === undefined)
      .map((key) => ({ key, count: uniqueColors[key].length })),
  ];
  return formedResult;
}

export async function getAllFonts() {
  let titleFont = "";
  let bodyFont = "";
  const result = [];
  try {
    await PowerPoint.run(async (context) => {
      context.presentation.slides.load({ id: true });
      context.presentation.slideMasters.load({ id: true });
      await context.sync();

      for (let i = 0; i < context.presentation.slides.items.length; i++) {
        const slide = context.presentation.slides.items[i];
        slide.shapes.load({ id: true, type: true, name: true });
        await context.sync();
        for (let j = 0; j < slide.shapes.items.length; j++) {
          const shape = slide.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, name: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    textFrame: { hasText: true, textRange: { font: { name: true } } },
                  });
                  await context.sync();
                  result.push(innerShape.textFrame.hasText ? innerShape.textFrame.textRange.font.name : undefined);
                  if (titleFont === "" && innerShape.name.startsWith("Title")) {
                    titleFont = innerShape.textFrame.textRange.font.name;
                  }
                  if (
                    bodyFont === "" &&
                    (innerShape.name.startsWith("Content") || innerShape.name.startsWith("Text"))
                  ) {
                    bodyFont = innerShape.textFrame.textRange.font.name;
                  }
                } catch (_) {}
              }
            } else {
              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { name: true } } },
                });
                await context.sync();
                result.push(shape.textFrame.hasText ? shape.textFrame.textRange.font.name : undefined);
                if (titleFont === "" && shape.name.startsWith("Title")) {
                  titleFont = shape.textFrame.textRange.font.name;
                }
                if (bodyFont === "" && (shape.name.startsWith("Content") || shape.name.startsWith("Text"))) {
                  bodyFont = shape.textFrame.textRange.font.name;
                }
              } catch (_) {}
            }
          } catch (_) {}
        }
      }

      for (let i = 0; i < context.presentation.slideMasters.items.length; i++) {
        const master = context.presentation.slideMasters.items[i];

        master.shapes.load({ id: true, type: true });
        master.layouts.load({ id: true });
        await context.sync();

        for (let j = 0; j < master.shapes.items.length; j++) {
          const shape = master.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, name: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    textFrame: { hasText: true, textRange: { font: { name: true } } },
                  });
                  await context.sync();
                  result.push(innerShape.textFrame.hasText ? innerShape.textFrame.textRange.font.name : undefined);
                  if (titleFont === "" && innerShape.name.startsWith("Title")) {
                    titleFont = innerShape.textFrame.textRange.font.name;
                  }
                  if (
                    bodyFont === "" &&
                    (innerShape.name.startsWith("Content") || innerShape.name.startsWith("Text"))
                  ) {
                    bodyFont = innerShape.textFrame.textRange.font.name;
                  }
                } catch (_) {}
              }
            } else {
              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { name: true } } },
                });
                await context.sync();
                result.push(shape.textFrame.hasText ? shape.textFrame.textRange.font.name : undefined);
                if (titleFont === "" && shape.name.startsWith("Title")) {
                  titleFont = shape.textFrame.textRange.font.name;
                }
                if (bodyFont === "" && (shape.name.startsWith("Content") || shape.name.startsWith("Text"))) {
                  bodyFont = shape.textFrame.textRange.font.name;
                }
              } catch (_) {}
            }
          } catch (error) {
            console.error("failed style", { shape, error });
          }
        }

        for (let j = 0; j < master.layouts.items.length; j++) {
          const layout = master.layouts.items[j];
          layout.shapes.load({ id: true, type: true });
          await context.sync();
          for (let k = 0; k < layout.shapes.items.length; k++) {
            const shape = layout.shapes.items[k];
            try {
              if (shape.type === "Group") {
                shape.group.shapes.load({ id: true, name: true });
                await context.sync();
                for (let j = 0; j < shape.group.shapes.items.length; j++) {
                  const innerShape = shape.group.shapes.items[j];
                  try {
                    innerShape.load({
                      textFrame: { hasText: true, textRange: { font: { color: true } } },
                    });
                    await context.sync();
                    result.push(innerShape.textFrame.hasText ? innerShape.textFrame.textRange.font.color : undefined);
                    if (titleFont === "" && innerShape.name.startsWith("Title")) {
                      titleFont = innerShape.textFrame.textRange.font.name;
                    }
                    if (
                      bodyFont === "" &&
                      (innerShape.name.startsWith("Content") || innerShape.name.startsWith("Text"))
                    ) {
                      bodyFont = innerShape.textFrame.textRange.font.name;
                    }
                  } catch (_) {}
                }
              } else {
                try {
                  shape.load({
                    textFrame: { hasText: true, textRange: { font: { name: true } } },
                  });
                  await context.sync();
                  result.push(shape.textFrame.hasText ? shape.textFrame.textRange.font.name : undefined);
                  if (titleFont === "" && shape.name.startsWith("Title")) {
                    titleFont = shape.textFrame.textRange.font.name;
                  }
                  if (bodyFont === "" && (shape.name.startsWith("Content") || shape.name.startsWith("Text"))) {
                    bodyFont = shape.textFrame.textRange.font.name;
                  }
                } catch (_) {}
              }
            } catch (error) {
              console.error("failed style", { shape, error });
            }
          }
        }
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }
  const uniqueFonts = Object.groupBy(
    result.filter((f) => f && f !== ""),
    (i) => i.trim()
  );

  return [
    { key: titleFont, count: 10000000 },
    { key: bodyFont, count: 10000000 },
    ...Object.keys(uniqueFonts)
      .sort((a, b) => uniqueFonts[b].length - uniqueFonts[a].length)
      .map((key) => ({ key, count: uniqueFonts[key].length })),
  ];
}

export async function setAllFonts(fontFamily) {
  try {
    await PowerPoint.run(async (context) => {
      context.presentation.slides.load({ id: true });
      context.presentation.slideMasters.load({ id: true });
      await context.sync();

      for (let i = 0; i < context.presentation.slides.items.length; i++) {
        const slide = context.presentation.slides.items[i];
        slide.shapes.load({ id: true, type: true, name: true });
        await context.sync();
        for (let j = 0; j < slide.shapes.items.length; j++) {
          const shape = slide.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, name: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    textFrame: { hasText: true, textRange: { font: { name: true } } },
                  });
                  await context.sync();
                  innerShape.textFrame.textRange.font.name = fontFamily;
                  await context.sync();
                } catch (_) {}
              }
            } else {
              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { name: true } } },
                });
                await context.sync();
                shape.textFrame.textRange.font.name = fontFamily;
                await context.sync();
              } catch (_) {}
            }
          } catch (_) {}
        }
      }

      for (let i = 0; i < context.presentation.slideMasters.items.length; i++) {
        const master = context.presentation.slideMasters.items[i];

        master.shapes.load({ id: true, type: true });
        master.layouts.load({ id: true });
        await context.sync();

        for (let j = 0; j < master.shapes.items.length; j++) {
          const shape = master.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, name: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    textFrame: { hasText: true, textRange: { font: { name: true } } },
                  });
                  await context.sync();
                  innerShape.textFrame.textRange.font.name = fontFamily;
                  await context.sync();
                } catch (_) {}
              }
            } else {
              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { name: true } } },
                });
                await context.sync();
                shape.textFrame.textRange.font.name = fontFamily;
                await context.sync();
              } catch (_) {}
            }
          } catch (error) {
            console.error("failed style", { shape, error });
          }
        }

        for (let j = 0; j < master.layouts.items.length; j++) {
          const layout = master.layouts.items[j];
          layout.shapes.load({ id: true, type: true });
          await context.sync();
          for (let k = 0; k < layout.shapes.items.length; k++) {
            const shape = layout.shapes.items[k];
            try {
              if (shape.type === "Group") {
                shape.group.shapes.load({ id: true, name: true });
                await context.sync();
                for (let j = 0; j < shape.group.shapes.items.length; j++) {
                  const innerShape = shape.group.shapes.items[j];
                  try {
                    innerShape.load({
                      textFrame: { hasText: true, textRange: { font: { color: true } } },
                    });
                    await context.sync();
                    innerShape.textFrame.textRange.font.name = fontFamily;
                    await context.sync();
                  } catch (_) {}
                }
              } else {
                try {
                  shape.load({
                    textFrame: { hasText: true, textRange: { font: { name: true } } },
                  });
                  await context.sync();
                  shape.textFrame.textRange.font.name = fontFamily;
                  await context.sync();
                } catch (_) {}
              }
            } catch (error) {
              console.error("failed style", { shape, error });
            }
          }
        }
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }

  return true;
}

export async function getAllColorsCategorised() {
  const result = [];
  try {
    await PowerPoint.run(async (context) => {
      context.presentation.slides.load({ id: true });
      context.presentation.slideMasters.load({ id: true });
      await context.sync();

      for (let i = 0; i < context.presentation.slides.items.length; i++) {
        const slide = context.presentation.slides.items[i];
        slide.shapes.load({ id: true, type: true, name: true });
        await context.sync();
        for (let j = 0; j < slide.shapes.items.length; j++) {
          const shape = slide.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, type: true, name: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    lineFormat: { color: true },
                    fill: { foregroundColor: true },
                  });
                  await context.sync();
                  result.push(
                    {
                      name: innerShape.name,
                      type: innerShape.type,
                      category: "line",
                      color: innerShape.lineFormat.color,
                    },
                    {
                      name: innerShape.name,
                      type: innerShape.type,
                      category: "fill",
                      color: innerShape.fill.foregroundColor,
                    }
                  );

                  try {
                    innerShape.load({
                      textFrame: { hasText: true, textRange: { font: { color: true } } },
                    });
                    await context.sync();
                    if (innerShape.textFrame.hasText) {
                      result.push({
                        name: innerShape.name,
                        type: innerShape.type,
                        category: "font",
                        color: innerShape.textFrame.textRange.font.color,
                      });
                    }
                  } catch (_) {}
                } catch (_) {}
              }
            } else {
              shape.load({
                lineFormat: { color: true },
                fill: { foregroundColor: true },
              });
              await context.sync();
              result.push(
                { name: shape.name, type: shape.type, category: "line", color: shape.lineFormat.color },
                { name: shape.name, type: shape.type, category: "fill", color: shape.fill.foregroundColor }
              );

              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { color: true } } },
                });
                await context.sync();
                if (shape.textFrame.hasText) {
                  result.push({
                    name: shape.name,
                    type: shape.type,
                    category: "font",
                    color: shape.textFrame.textRange.font.color,
                  });
                }
              } catch (_) {}
            }
          } catch (_) {}
        }
      }

      for (let i = 0; i < context.presentation.slideMasters.items.length; i++) {
        const master = context.presentation.slideMasters.items[i];

        master.shapes.load({ id: true, type: true, name: true });
        master.layouts.load({ id: true });
        await context.sync();

        for (let j = 0; j < master.shapes.items.length; j++) {
          const shape = master.shapes.items[j];
          try {
            if (shape.type === "Group") {
              shape.group.shapes.load({ id: true, type: true, name: true });
              await context.sync();
              for (let j = 0; j < shape.group.shapes.items.length; j++) {
                const innerShape = shape.group.shapes.items[j];
                try {
                  innerShape.load({
                    lineFormat: { color: true },
                    fill: { foregroundColor: true },
                  });
                  await context.sync();
                  result.push(
                    {
                      name: innerShape.name,
                      type: innerShape.type,
                      category: "line",
                      color: innerShape.lineFormat.color,
                    },
                    {
                      name: innerShape.name,
                      type: innerShape.type,
                      category: "fill",
                      color: innerShape.fill.foregroundColor,
                    }
                  );

                  try {
                    innerShape.load({
                      textFrame: { hasText: true, textRange: { font: { color: true } } },
                    });
                    await context.sync();
                    if (innerShape.textFrame.hasText) {
                      result.push({
                        name: innerShape.name,
                        type: innerShape.type,
                        category: "font",
                        color: innerShape.textFrame.textRange.font.color,
                      });
                    }
                  } catch (_) {}
                } catch (_) {}
              }
            } else {
              shape.load({
                lineFormat: { color: true },
                fill: { foregroundColor: true },
              });
              await context.sync();
              result.push(
                { name: shape.name, type: shape.type, category: "line", color: shape.lineFormat.color },
                { name: shape.name, type: shape.type, category: "fill", color: shape.fill.foregroundColor }
              );

              try {
                shape.load({
                  textFrame: { hasText: true, textRange: { font: { color: true } } },
                });
                await context.sync();
                if (shape.textFrame.hasText) {
                  result.push({
                    name: shape.name,
                    type: shape.type,
                    category: "font",
                    color: shape.textFrame.textRange.font.color,
                  });
                }
              } catch (_) {}
            }
          } catch (error) {
            console.error("failed style", { shape, error });
          }
        }

        for (let j = 0; j < master.layouts.items.length; j++) {
          const layout = master.layouts.items[j];
          layout.shapes.load({ id: true, type: true, name: true });
          await context.sync();
          for (let k = 0; k < layout.shapes.items.length; k++) {
            const shape = layout.shapes.items[k];
            try {
              if (shape.type === "Group") {
                shape.group.shapes.load({ id: true, type: true, name: true });
                await context.sync();
                for (let j = 0; j < shape.group.shapes.items.length; j++) {
                  const innerShape = shape.group.shapes.items[j];
                  try {
                    innerShape.load({
                      lineFormat: { color: true },
                      fill: { foregroundColor: true },
                    });
                    await context.sync();
                    result.push(
                      {
                        name: innerShape.name,
                        type: innerShape.type,
                        category: "line",
                        color: innerShape.lineFormat.color,
                      },
                      {
                        name: innerShape.name,
                        type: innerShape.type,
                        category: "fill",
                        color: innerShape.fill.foregroundColor,
                      }
                    );

                    try {
                      innerShape.load({
                        textFrame: { hasText: true, textRange: { font: { color: true } } },
                      });
                      await context.sync();
                      if (innerShape.textFrame.hasText) {
                        result.push({
                          name: innerShape.name,
                          type: innerShape.type,
                          category: "font",
                          color: innerShape.textFrame.textRange.font.color,
                        });
                      }
                    } catch (_) {}
                  } catch (_) {}
                }
              } else {
                shape.load({
                  lineFormat: { color: true },
                  fill: { foregroundColor: true },
                });
                await context.sync();
                result.push(
                  { name: shape.name, type: shape.type, category: "line", color: shape.lineFormat.color },
                  { name: shape.name, type: shape.type, category: "fill", color: shape.fill.foregroundColor }
                );

                try {
                  shape.load({
                    textFrame: { hasText: true, textRange: { font: { color: true } } },
                  });
                  await context.sync();
                  if (shape.textFrame.hasText) {
                    result.push({
                      name: shape.name,
                      type: shape.type,
                      category: "font",
                      color: shape.textFrame.textRange.font.color,
                    });
                  }
                } catch (_) {}
              }
            } catch (error) {
              console.error("failed style", { shape, error });
            }
          }
        }
      }
    });
  } catch (error) {
    console.error("Error running PowerPoint command", { error });
  }

  console.warn(
    "Categorized colors collected",
    result.filter((f) => f.color && f.color !== "")
  );
  const cleaned = result.filter((f) => f.color && f.color !== "");

  const allUniqueColors = Object.groupBy(cleaned, (s) => s.color);
  const orderedAllColors = Object.keys(allUniqueColors)
    .sort((a, b) => allUniqueColors[b].length - allUniqueColors[a].length)
    .map((key) => ({ key, count: allUniqueColors[key].length }));
  console.warn("All colors", orderedAllColors);

  const shapeFills = cleaned.filter((f) => f.type === "GeometricShape" && f.category === "fill");
  const uniqueShapeFills = Object.groupBy(shapeFills, (s) => s.color);
  const orderedShapeFills = Object.keys(uniqueShapeFills)
    .sort((a, b) => uniqueShapeFills[b].length - uniqueShapeFills[a].length)
    .map((key) => ({ key, count: uniqueShapeFills[key].length }));

  console.warn("Shape fills", { shapeFills, uniqueShapeFills, orderedShapeFills });

  const typedColors = Object.groupBy(cleaned, (s) => s.type + "_" + s.category);
  const orderedTypedColors = Object.keys(typedColors)
    .sort((a, b) => typedColors[b].length - typedColors[a].length)
    .map((key) => ({ key, count: typedColors[key].length }));

  const namedShapeColors = Object.groupBy(cleaned, (s) => s.name.split(" ")[0] + "_" + s.type + "_" + s.category);
  const orderedNamedShapeColors = Object.keys(namedShapeColors)
    .sort((a, b) => namedShapeColors[b].length - namedShapeColors[a].length)
    .map((key) => ({ key, count: namedShapeColors[key].length }));

  console.warn("Typed colors", { orderedTypedColors, orderedNamedShapeColors });
}
